module.exports = __webpack_public_path__ + "img/Effective Negotiator.08fb995d.png";